import { useContext } from 'react'
import { AuthContext } from './Provider'

export const useAuthContext = () => useContext(AuthContext)
